import { html, PropertyValues } from 'lit';
import { property } from 'lit/decorators.js';
import './public-app-content-loader'
import { PublicAppElement } from './public-app-element';

export class PublicAppWidget extends PublicAppElement {
    private valid: boolean;
    private timerHandler: { handle?: any; };
    private _refreshInterval: Number = 0;

    get refreshInterval(): Number {
        return this._refreshInterval;
    }

    @property({ type: Number })
    set refreshInterval(value: Number) {
        const oldValue = this._refreshInterval;
        this._refreshInterval = value;
        this.requestUpdate('refreshInterval', oldValue);
    }

    private _widgetId: string = '';
    get widgetId(): string {
        return this._widgetId;
    }
    @property({ type: String })
    set widgetId(value: string) {
        const oldValue = this._widgetId;
        this._widgetId = value;
        this.requestUpdate('widgetId', oldValue);
    }

    private _widgetType: string = '';
    get widgetType(): string {
        return this._widgetType;
    }
    @property({ type: String })
    set widgetType(value: string) {
        const oldValue = this._widgetType;
        this._widgetType = value;
        this.requestUpdate('widgetType', oldValue);
    }

    private _widgetTitle: string = '';
    get widgetTitle(): string {
        return this._widgetTitle;
    }
    @property({ type: String })
    set widgetTitle(value: string) {
        const oldValue = this._widgetTitle;
        this._widgetTitle = value;
        this.requestUpdate('widgetTitle', oldValue);
    }

    private _url: string = '';
    get url(): string {
        return this._url;
    }

    @property({ type: String })
    set url(value: string) {
        const oldValue = this._url;
        this._url = value;
        this.requestUpdate('url', oldValue);
    }

    firstUpdated(changedProperties: PropertyValues) {
        this.setNextRefresh();
    }
    // When the element is added, set the valid flag as true.  The timer will depend on this flag.  if true, it continues else stop the timer
    connectedCallback() {
        super.connectedCallback();
        this.valid = true;
    }

    // When the element is removed, set the valid flag as false.  The timer will depend on this flag.  if true, it continues else stop the timer
    disconnectedCallback() {
        this.valid = false;
        super.disconnectedCallback();
    }
    // jQuery UI needs the handle to be outside shadow DOM, but the properties and behavior inside the handle elements are rendered in the shadow DOM
    // To render the handle inside a div that jQuery UI can access, we do the following steps
    // 1. Created a slot with name "widgethandle"
    // 2. Every widget will provide a slot - a div which will be the handle to jQuery UI
    // 3. The widget render will render the header contents to a div with id widgetbox-header
    // 4. After the rendering, when the slot gets changed, move the contents in widgetbox-header to the div from the slot
    onSlotChange(e: Event) {
        var el = e.target as any;
        const childNodes = el.assignedNodes({ flatten: true });
        if (el.name === 'widgethandle') {
            if (childNodes && childNodes.length) {
                childNodes[0].childNodes.forEach(element => { element.remove(); });
                childNodes[0].appendChild(this.shadowRoot?.querySelector('#widgetbox-header'));
            }
        } else if (el.name === 'headerLinks') {
            const container = (this.shadowRoot?.querySelector('#headerLinkContainer') || this.querySelector('#headerLinkContainer'));
            let fChild = childNodes[0];
            if (container && fChild) {
                container.appendChild(fChild);
            }
        }
    }
    setNextRefresh() {
        // If already there, clear the timer
        if (this.timerHandler?.handle) {
            clearTimeout(this.timerHandler.handle);
            this.timerHandler.handle = 0;
        }

        // Set the timer only if there is a non zero refreshInterval
        if (this.refreshInterval) {
            var that = this;
            if (!this.timerHandler) {
                this.timerHandler = {};
            }

            // Save the handle to enable stopping when required
            this.timerHandler.handle = setTimeout(function (event) { that.reload(); }, Number(this.refreshInterval));
        }
    }

    reload() {
        clearTimeout(this.timerHandler.handle);
        this.timerHandler.handle = 0;
        if (this.valid) {
            console.log(this.widgetTitle, "Widget (", this.widgetId, ") is reloading now!");
            let loader: any = this.getPublicAppElementForSelector("public-app-content-loader") || this.getPublicAppElementForSelector("public-app-tab-container");
            loader?.reload();
            this.setNextRefresh();
        } else {
            console.log(this.widgetTitle, "Widget (", this.widgetId, ") is removed from dom, so stoping the timer!");
        }
    }

    renderHeaderLinks() {
        return html``;
    }
    renderContentLoader() {
        return html`<public-app-content-loader .systemEnv=${this.runMode} .appVersion=${this.appVersion}  url="${this._url}" widgetId=${this._widgetId}></public-app-content-loader>`;
    }
    render() {
        return html`
            <link rel="stylesheet" href="/css/global.css?v=${this.appVersion}">
            <slot name="widgethandle" @slotchange="${this.onSlotChange}"></slot>
            <slot name="headerLinks" @slotchange="${this.onSlotChange}"></slot>
            <div id="widgetbox-header" class="tableTop draggable ${this._widgetType === 'small' ? 'widget-handle-small' : 'widget-handle-large'}">
                <div class="public-app-widget-table d-flex justify-content-between flex-wrap">
                    
                        <div class="public-app-widget-table-title">${this._widgetTitle}</div>
                        <div class="header-links">
                            <div id="headerLinkContainer" class="d-flex justify-content-between">
                            </div>
                        </div>
                    
                </div>
            </div>
            <div class="cb"></div>

            <div id="${this._widgetId}Container" class="tableMid ${this._widgetType === 'small' ? 'container-small' : 'container-large'}" >
            <slot name="content"></slot>
            ${this._url ? this.renderContentLoader() : html``}
            </div>

            <div class="cb"></div>
    `;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        'public-app-widget': PublicAppWidget;
    }
}